import { IBuyTicketsSettings, defaultCalendarSettings } from '../../classes/buytickets';
import { ActionType, IBuyTicketsStateAction } from '../../classes/buytickets-actions';

import * as moment from 'moment';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarSettingsReducer(state: IBuyTicketsSettings = defaultCalendarSettings, action: IBuyTicketsStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value } as IBuyTicketsSettings;
        }
        default:
            return state;
    }
}
